import Layout from "../../../../components/layout";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";
import { useNavigationModule } from "@agp/shared.user-app/application/context/navigation";
import { useCallback } from "react";
import { Item } from "semantic-ui-react";
import ServiceLocator from "../../../../../domain/service-locator";

const AreasPage = () => {
  const navigation = useNavigationModule();
  const areas = ServiceLocator.LocalizedEntityRepository.entities.watch().areas;

  // --- Callbacks---
  const onClickArea = useCallback((areaId: string) => {
    navigation.push(
      "tours",
      { areaId },
      { pageInType: "slideLeft", pageOutType: "slideLeft" }
    );
  }, []);

  return (
    <Layout
      headerLeftComponents={["back"]}
      backTransitionOption={{ pageInType: "fade", pageOutType: "fade" }}
    >
      <AnimatedPageTransition>
        <div>
          <Item.Group unstackable divided>
            {areas!.map((x, i) => (
              <Item key={`areas-area-${i}`} onClick={() => onClickArea(x.id)}>
                <Item.Image
                  src={x.thumbnailUrl == "" ? "/no-image.png" : x.thumbnailUrl}
                />
                <Item.Content>
                  <Item.Header>{x.name}</Item.Header>
                  <Item.Description>{x.description}</Item.Description>
                </Item.Content>
              </Item>
            ))}
          </Item.Group>
        </div>
      </AnimatedPageTransition>
    </Layout>
  );
};

export default AreasPage;
